<div class="home-container">
  <div class="stacked-layout">

    <!-- BLOCK 1: Introduction & Content Details (Top Full Width) -->
    <div class="block intro-block">
      <div class="block-card">
        <h2 class="block-title">Cityspeak - Bigg Boss</h2>
        <div class="intro-text" [innerHTML]="introText"></div>
        <div class="intro-links">
          <a class="feature-link" href="#opinion-poll">
            <span class="feature-icon">⚡</span>
            <span class="link-text">Live Public Poll</span>
            <img src="assets/Images/Live_heart.gif" alt="Live" class="live-gif-icon">
          </a>
          <a class="feature-link" href="#contestants">
            <span class="feature-icon">⚡</span>
            <span class="link-text">Contestants</span>
          </a>
          <a class="feature-link" href="#hot-news">
            <span class="feature-icon">⚡</span>
            <span class="link-text">Hot News</span>
          </a>
          <a class="feature-link" href="#opinion-poll">
            <span class="feature-icon">⚡</span>
            <span class="link-text">BB10 Insights</span>
          </a>
        </div>
      </div>
    </div>

    <!-- BLOCK 2: Poster Image Carousel Slider (Image Only) -->
    <div class="block carousel-block" *ngIf="carouselSlides && carouselSlides.length > 0">
      <div class="carousel-container" (mouseenter)="stopAutoSlide()" (mouseleave)="startAutoSlide()">
        <div class="carousel-slide" *ngFor="let slide of carouselSlides; let i = index"
          [class.active]="i === currentSlideIndex">
          <img [src]="slide.imgurl" [alt]="'Poster slide ' + i" [title]="slide.imgid" class="poster-image">
        </div>
        <button class="carousel-btn prev-btn" (click)="prevSlide()" aria-label="Previous slide">&#10094;</button>
        <button class="carousel-btn next-btn" (click)="nextSlide()" aria-label="Next slide">&#10095;</button>
        <div class="carousel-dots">
          <span *ngFor="let slide of carouselSlides; let i = index" class="dot" [class.active]="i === currentSlideIndex"
            (click)="goToSlide(i)"></span>
        </div>
      </div>
    </div>

    <!-- BLOCK 3: Opinion Poll (Full Width / Left Aligned) -->
    <div class="block poll-block" id="opinion-poll">
      <div class="block-card poll-card">
        <h2 class="block-title">Opinion Poll</h2>

        <p class="poll-message" *ngIf="isPollLoading">Loading poll...</p>
        <p class="poll-message error" *ngIf="!isPollLoading && pollError">{{ pollError }}</p>

        <ng-container *ngIf="!isPollLoading && !pollError">
          <ng-container *ngIf="!hasVoted; else pollResults">
            <h3 class="poll-question">{{ pollQuestion }}</h3>

            <div class="poll-options">
              <label class="poll-option" *ngFor="let option of pollOptions"
                [class.selected]="selectedPollOption === option.value">
                <input type="checkbox" [checked]="selectedPollOption === option.value"
                  (change)="selectPollOption(option.value)">
                <span>{{ option.label }}</span>
              </label>
            </div>

            <button class="vote-button" [disabled]="!selectedPollOption" (click)="submitVote()">
              Vote Now
            </button>
          </ng-container>

          <ng-template #pollResults>
            <h3 class="poll-question">{{ pollQuestion }}</h3>
            <div class="poll-results">
              <div class="result-row" *ngFor="let option of pollOptions">
                <div class="result-label-row">
                  <span>{{ option.label }}</span>
                  <span>
                    <strong>{{ getFormattedPercentage(option) }}%</strong>
                    ({{ option.votes | number }} votes)
                  </span>
                </div>
                <div class="result-bar">
                  <div class="result-bar-fill" [style.width.%]="getVotePercentage(option)"></div>
                </div>
              </div>
            </div>
            <p class="total-votes">Total Votes: <strong>{{ totalVotes | number }}</strong></p>
          </ng-template>

          <!-- WhatsApp Share Button -->
          <button class="whatsapp-share-btn" (click)="shareOnWhatsApp()" aria-label="Share on WhatsApp">
            <svg class="whatsapp-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.15c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.13 8.13 0 0 1-1.25-4.38c0-4.5 3.66-8.15 8.16-8.15 2.18 0 4.22.85 5.76 2.39 1.54 1.54 2.39 3.58 2.39 5.76 0 4.5-3.66 8.15-8.15 8.15zm4.47-6.1c-.25-.12-1.47-.72-1.7-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.79.97-.14.17-.29.19-.53.07-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.15-1.18-.06-.11-.22-.17-.46-.29z"/>
            </svg>
            <span>Share on WhatsApp</span>
          </button>
        </ng-container>
      </div>
    </div>

    <!-- BLOCK 4: Two Column Section (Bigg Boss News, Contestants) -->
    <div class="block news-contestants-block">
      <div class="news-contestants-grid">

        <!-- Column 1: Bigg Boss News -->
        <div class="block-card" id="hot-news">
          <h2 class="block-title">Bigg Boss News</h2>
          <div class="news-video-container" *ngIf="newsVideoUrl">
            <iframe class="news-video-iframe" [src]="newsVideoUrl" title="Bigg Boss News Video" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
            </iframe>
          </div>
        </div>

        <!-- Column 2: Contestants -->
        <div class="block-card" id="contestants">
          <div class="contestants-section-header">
            <h2 class="block-title">Contestants - Current Position</h2>
            <div class="header-share-actions">
              <button type="button" class="header-share-btn wa-header-btn" (click)="shareContestantsOnWhatsApp()" title="Share on WhatsApp" aria-label="Share on WhatsApp">
                <svg class="header-share-svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.15c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.13 8.13 0 0 1-1.25-4.38c0-4.5 3.66-8.15 8.16-8.15 2.18 0 4.22.85 5.76 2.39 1.54 1.54 2.39 3.58 2.39 5.76 0 4.5-3.66 8.15-8.15 8.15zm4.47-6.1c-.25-.12-1.47-.72-1.7-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.79.97-.14.17-.29.19-.53.07-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.15-1.18-.06-.11-.22-.17-.46-.29z"/>
                </svg>
              </button>
              <button type="button" class="header-share-btn more-header-btn" (click)="shareContestants()" title="Share" aria-label="Share">
                <svg class="header-share-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="18" cy="5" r="3"></circle>
                  <circle cx="6" cy="12" r="3"></circle>
                  <circle cx="18" cy="19" r="3"></circle>
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                </svg>
              </button>
            </div>
          </div>
          <div class="contestants-list">
            <div class="contestant-item" *ngFor="let contestant of contestants">
              <div class="contestant-header-row">
                <div class="contestant-name-row">
                  <span class="contestant-name" [title]="contestant.bbc_name">{{ contestant.bbc_name }}</span>
                  <div class="contestant-info-tooltip-wrapper">
                    <span class="info-icon" tabindex="0" role="button" aria-label="Contestant Details">ℹ</span>
                    <div class="info-card-popover">
                      <div class="info-card-row">
                        <span class="info-label">Actual Name:</span>
                        <span class="info-val">{{ contestant.bbc_actual_name }}</span>
                      </div>
                      <div class="info-card-row">
                        <span class="info-label">Profession:</span>
                        <span class="info-val">{{ contestant.bbc_profession }}</span>
                      </div>
                      <div class="info-card-row">
                        <span class="info-label">Age:</span>
                        <span class="info-val">{{ contestant.bbc_age }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <span class="contestant-badge"
                  [ngClass]="getContestantStatusClass(contestant.bbc_currentweek_position)">
                  {{ contestant.bbc_currentweek_position }}
                </span>
              </div>
              <div class="contestant-avatar-container">
                <img [src]="contestant.bbc_img_url" (error)="$any($event.target).src = 'assets/Images/zoya1.jpg'"
                  [alt]="contestant.bbc_name" class="contestant-avatar">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>